import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import AgilitePage from "@/pages/AgilitePage";
import QuizzListPage from "@/pages/QuizzListPage";
import FlashDiagPage from "@/pages/FlashDiagPage";
import ArticlePage from "@/pages/ArticlePage";
import QuizPage from "@/pages/QuizPage";
import WhitepaperPage from "@/pages/WhitepaperPage";
import PrivacyPage from "@/pages/PrivacyPage";
import LegalPage from "@/pages/LegalPage";
import AdminPage from "@/pages/AdminPage";
import { CookieBanner } from "@/components/site/CookieBanner";
import { trackPageview } from "@/lib/analytics";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth" }), 300);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  useEffect(() => {
    if (!pathname.startsWith("/admin")) trackPageview(pathname);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollManager />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/agilite" element={<AgilitePage />} />
          <Route path="/agilite/:slug" element={<ArticlePage />} />
          <Route path="/quizz" element={<QuizzListPage />} />
          <Route path="/quizz/:quizId" element={<QuizPage />} />
          <Route path="/flashdiag" element={<FlashDiagPage />} />
          <Route path="/livre-blanc" element={<WhitepaperPage />} />
          <Route path="/confidentialite" element={<PrivacyPage />} />
          <Route path="/mentions-legales" element={<LegalPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
        <CookieBanner />
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" richColors />
    </div>
  );
}

export default App;
